import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import Breadcrumbs from './Breadcrumbs';
interface LayoutProps {
  children: ReactNode;
  userRole: 'Program Manager' | 'Founder';
  toggleRole: () => void;
}
const Layout: React.FC<LayoutProps> = ({
  children,
  userRole,
  toggleRole
}) => {
  return <div className="flex h-screen bg-gray-50" data-id="element-29">
      <Sidebar userRole={userRole} data-id="element-30" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-31">
        <TopBar userRole={userRole} toggleRole={toggleRole} data-id="element-32" />
        <div className="flex flex-1 overflow-hidden" data-id="element-33">
          <main className="flex-1 overflow-auto pb-6" data-id="element-34">{children}</main>
        </div>
      </div>
    </div>;
};
export default Layout;